import {Directive, ElementRef, Input, OnChanges, OnInit} from "@angular/core";
import * as md5 from "md5";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../store";

@Directive({
  selector: '[dbGravatar]',
  standalone: true,
})
export class GravatarDirective implements OnInit, OnChanges {

  @Input() email: string;
  @Input() fallback: string = 'assets/avatar_4x.png';
  @Input() size: number = 16;
  private companyInfo: string;

  constructor(
    private elementRef: ElementRef,
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  ngOnInit() {
    this._store.select(fromStore.getCompanyInfoLoaded)
      .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getCompanyInfo)),
          first()
      )
      .subscribe((companyInfo: any) => {
        this.companyInfo = companyInfo.agency.domain || window.location.hostname;
      });
  }

  ngOnChanges() {
    const _domain = this.companyInfo || window.location.hostname;
    const fallback: string = `${_domain}/${this.fallback}`;
    this.elementRef.nativeElement.src = this.email ? `//www.gravatar.com/avatar/${md5(this.email)}?s=${this.size}&d=${encodeURIComponent(fallback)}` : '';
  }

}
